var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThreeDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 18,
    viewBox: "0 0 4 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.95053C0.928823 3.95053 0.0585938 3.0803 0.0585938 2.01074C0.0585938 0.941186 0.928823 0.0693359 2 0.0693359C3.07118 0.0693359 3.94141 0.941186 3.94141 2.01074C3.94141 3.0803 3.07118 3.95053 2 3.95053Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99963 10.8306C0.928658 10.8306 0.0585938 9.96058 0.0585938 8.89123C0.0585938 7.82188 0.928658 6.9502 1.99963 6.9502C3.0706 6.9502 3.94067 7.82188 3.94067 8.89123C3.94067 9.96058 3.0706 10.8306 1.99963 10.8306Z",
    fill: "#BDBDBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99963 17.7115C0.928658 17.7115 0.0585938 16.8414 0.0585938 15.7721C0.0585938 14.7027 0.928658 13.8311 1.99963 13.8311C3.0706 13.8311 3.94067 14.7027 3.94067 15.7721C3.94067 16.8414 3.0706 17.7115 1.99963 17.7115Z",
    fill: "#BDBDBD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/threeDots.21d74fa64f8604c70ebe0d40099ad138.svg";
export { ForwardRef as ReactComponent };